/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = getHolder;
